import '@angular/compiler';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageRegisterComponent } from './page.register/page.register.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PagePostsRegistrationComponent } from './page.posts.registration/page.posts.registration.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageErrorComponent } from './page.error/page.error.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';

const INDEX_PAGE = "login";

import { URLPattern } from "urlpattern-polyfill";
import { Injectable, NgModule } from '@angular/core';
import { CanDeactivate, RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "login",
                component: PageLoginComponent,
                "app_id": "page.login"
            },
            {
                "path": "register",
                component: PageRegisterComponent,
                "app_id": "page.register"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "posts/new/:workspaceId/edit",
                component: PagePostsRegistrationComponent,
                "app_id": "page.posts.registration"
            },
            {
                "path": "error/:code",
                component: PageErrorComponent,
                "app_id": "page.error"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            },
            {
                "path": "home",
                component: PageHomeComponent,
                "app_id": "page.home"
            }
        ]
    },
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

@Injectable({ providedIn: 'root' })
export class PendingWorkGuard implements CanDeactivate<any> {
    public canDeactivate(
        _component: any,
        _currentRoute: any,
        _currentState: any,
        nextState: any,
    ) {
        const guard = (window as any).__wizPendingWorkGuard;
        return typeof guard === 'function'
            ? guard(`${nextState?.url || ''}`)
            : true;
    }
}

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    path: '',
    pathMatch: 'full',
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component,
            canDeactivate: [PendingWorkGuard]
        });
    }
    routes.push(router);
}

// Angular evaluates routes in declaration order. Keep the catch-all last so
// valid WIZ pages get a chance to match before the 404 fallback.
routes.push({
    matcher: (url: any) => ({ consumed: url, posParams: {} }),
    redirectTo: 'error/404'
});

@NgModule({ imports: [RouterModule.forRoot(routes, { enableViewTransitions: true })], exports: [RouterModule] })
export class AppRoutingModule { }
